<template>

    <div v-for="checkbox in list" class="checkbox-group themes-list">
        <input type="checkbox" :id="checkbox.key" :value="checkbox.value" v-model="value"/>
        <label :for="checkbox.key" class="checkbox-label theme-checkbox" :style="getStyle(checkbox)"  :data-colour=" checkbox.colour ">{{checkbox.label}}</label>
    </div>



</template>

<script>

export default
{
    name: "InputThemesList"
}
</script>

<script setup>

import { ref, watch, computed } from "vue";
import { useStore }   from "vuex";
import { getValue, getList }        from "../composables/useData";
let store = useStore();

let props = defineProps(["field", "data", "datastore"]);
let emits = defineEmits(["update"])
let value = ref (/*useData.*/getValue(props.field, store.state, "user.profile")  ?? [] );

let list = computed ( () => getList(props.field, props.data, props.datastore));


watch (value, () => emits("update", {key: props.field.key, value: value.value}) )

function getStyle(checkbox)
{
    return 'background-color: ' + checkbox.colour + ';';
}


function hasField (fields)
{
    let strKey = props.field.key;

    return fields.includes(strKey);
}

function getKey ()
{
    return props.field.key;
}

defineExpose({ hasField, getKey });

</script>
<style scoped>

</style>
